import React from "react";
import "./footer.css";
import { VERSION } from "../../../../version";

function Footer() {
  return (
      <>
        {/* Subtle version footer */}
        <div className="version-footer">
          Version: {VERSION.full}
        </div>
      </>
  );
}

export default Footer;
